import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list'; 
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectModule } from 'primeng/select';

import { TopClickNavComponent } from './top-click-nav/top-click-nav.component';
import { TopSecondaryNavComponent } from './top-secondary-nav/top-secondary-nav.component';
import { SearchNavComponent } from './search-nav/search-nav.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { UserAcknowledgementComponent } from './user-acknowledgement/user-acknowledgement.component';
import { MatSideNavComponent } from './mat-side-nav/mat-side-nav.component';

@NgModule({
	declarations: [
		TopClickNavComponent
		, TopSecondaryNavComponent
		, SearchNavComponent
		, SideNavComponent
		, UserAcknowledgementComponent
		, MatSideNavComponent
	]
    , imports: [
		RouterModule
		, CommonModule
		, FormsModule
		, MatListModule
		, MatTabsModule
		, FontAwesomeModule
        , MatButtonToggleModule
        , MatTooltipModule
        , SelectModule
	]
    , exports: [ 
		TopClickNavComponent
		, TopSecondaryNavComponent
		, SearchNavComponent
		, SideNavComponent
		, UserAcknowledgementComponent 
		, MatSideNavComponent
		, MatListModule
		, MatTabsModule
		, FontAwesomeModule
        , MatButtonToggleModule
        , MatTooltipModule
        , SelectModule
	]
})
export class NavigationModule { }
